import PropTypes from 'prop-types'
import exact from 'prop-types-exact'

import CloseIcon from 'assets/images/icons/times-light.svg'
import Button from 'components/lib/html_elements/button'
import Icon from 'components/lib/icon'
import { useSheet } from '../hooks'

import styles from './index.css'

const Header = ({ title, isLoading, children }) => {
  const { toggleSheet } = useSheet()

  return (
    <div className={styles.base}>
      {isLoading && (
        <div className={styles.loading}>
          <div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      {!isLoading && (
        <Button className={styles.closeButton} onClick={() => toggleSheet(false)}>
          <Icon icon={<CloseIcon />} />
        </Button>
      )}
      {title && <h2>{title}</h2>}
      <div className={styles.children}>{children}</div>
    </div>
  )
}

Header.propTypes = exact({
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isLoading: PropTypes.bool,
  icon: PropTypes.string,
  children: PropTypes.any
})

export default Header
